import { FormField } from "components/form/FormField/FormField";

export const ScreeningAndThreatmentHistory = ({ form }) => {
  return (
    <>
      <h2
        style={{
          fontSize: "20px",
          lineHeight: "32px",
          marginTop: "24px",
        }}
      >
        Screening and Threatment History
      </h2>

      <FormField name="screeningAndThreatmentHistory">
        <textarea
          className="form-control textareaform-control"
          style={{ minHeight: "100px" }}
          {...form.register("screeningAndThreatmentHistory")}
        />
      </FormField>
    </>
  );
};
